export default "__VITE_ASSET__mNFMK5gn__"